document.addEventListener('DOMContentLoaded', () => {
    const headerThirdNav = document.querySelector('.header__third-nav-container');
    if (!headerThirdNav) return;
  
    const customerServiceItem = headerThirdNav.querySelector('[data-title="Customer Service"]');
    if (!customerServiceItem) return;
  
    const detailsElement = customerServiceItem.querySelector('details');
    const summaryElement = customerServiceItem.querySelector('summary');
    const dropdownElement = customerServiceItem.querySelector('.header__customer-service-dropdown');
  
    if (!detailsElement || !summaryElement || !dropdownElement) return;
  
    let isUpdateScheduled = false;

    const updateArrowPosition = () => {
      const dropdownRect = dropdownElement.getBoundingClientRect();
      const summaryRect = summaryElement.getBoundingClientRect();
  
      if (!dropdownRect.width || !summaryRect.width) return;
  
      const offset = summaryRect.left + summaryRect.width / 2 - dropdownRect.left;
      dropdownElement.style.setProperty('--customer-service-arrow-offset', `${offset}px`);
      dropdownElement.dataset.arrowReady = 'true';
    };
  
    const scheduleUpdate = (event) => {
      if (!detailsElement.open && event && !['toggle', 'mouseenter', 'focus', 'click'].includes(event.type)) return;
      if (isUpdateScheduled) return;
      isUpdateScheduled = true;
      requestAnimationFrame(() => {
        isUpdateScheduled = false;
        updateArrowPosition();
      });
    };
  
    summaryElement.addEventListener('mouseenter', scheduleUpdate);
    summaryElement.addEventListener('focus', scheduleUpdate);
    summaryElement.addEventListener('click', scheduleUpdate);
    detailsElement.addEventListener('toggle', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    document.addEventListener('scroll', scheduleUpdate, { passive: true, capture: true });
  
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(scheduleUpdate);
      observer.observe(summaryElement);
      observer.observe(dropdownElement);
    }

    if ('requestIdleCallback' in window) {
      requestIdleCallback(scheduleUpdate, { timeout: 1000 });
    } else {
      setTimeout(scheduleUpdate, 100);
    }
  });
  
  (function () {
    function getFormForGroup(group) {
      var formId = group.getAttribute('data-form-id');
      if (formId) return document.getElementById(formId);
      return group.closest('form');
    }
  
    function syncQuantityValue(group, value) {
      if (!group || !value) return;
  
      var hidden = group.querySelector('[data-quantity-bundle-value]');
      if (hidden) hidden.value = value;
  
      var form = getFormForGroup(group);
      if (!form) return;
  
      var qtyInput =
        form.querySelector('[data-product-form-quantity]') ||
        form.querySelector('input[name="quantity"]');
  
      if (qtyInput) qtyInput.value = value;
    }
  
    function setSelectedState(group, radio) {
      if (!group || !radio) return;
      group.querySelectorAll('.quantity-bundle-option').forEach(option => {
        option.classList.toggle('is-selected', option.contains(radio));
      });
    }
  
    function initializeGroup(group) {
      if (!group) return;
      var checked = group.querySelector('[data-quantity-bundle-radio]:checked');
      if (checked) {
        syncQuantityValue(group, checked.value);
        setSelectedState(group, checked);
      }
    }
  
    function initializeAll() {
      document.querySelectorAll('[data-quantity-bundle]').forEach(initializeGroup);
    }
  
    document.addEventListener('change', event => {
      if (!event.target.matches('[data-quantity-bundle-radio]')) return;
      const group = event.target.closest('[data-quantity-bundle]');
      syncQuantityValue(group, event.target.value);
      setSelectedState(group, event.target);
    });
  
    document.addEventListener('product:rerender', () => {
      requestAnimationFrame(initializeAll);
    });
  
    document.addEventListener('click', event => {
      const option = event.target.closest('.quantity-bundle-option');
      if (!option) return;
  
      const radio = option.querySelector('[data-quantity-bundle-radio]');
      if (radio && !radio.checked) radio.click();
    });
  
    const scheduleInit = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(initializeAll, { timeout: 2000 });
      } else {
        setTimeout(initializeAll, 200);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleInit);
    } else {
      scheduleInit();
    }
  })();

  (function () {
    let _spVariantId = null;
    let _spProductId = null;
    let _autoAddInProgress = false;
    let _userOptedOut = sessionStorage.getItem('sp_opted_out') === '1'; // persists across cart-page reloads
    let _spWasInCart = false;    // tracks previous cart state to detect line-item removal

    async function getShippingProtectionVariant() {
      if (_spVariantId) return { variantId: _spVariantId, productId: _spProductId };
      try {
        const product = await (await fetch('/products/shipping-protection.js')).json();
        const variant = product.variants?.find((v) => v.available) || product.variants?.[0];
        if (!variant) return null;
        _spVariantId = String(variant.id);
        _spProductId = product.id;
        return { variantId: _spVariantId, productId: _spProductId };
      } catch {
        return null;
      }
    }

    let _cartDrawer;
    function setCartDrawerBusy(busy) {
      _cartDrawer = _cartDrawer || document.querySelector('cart-drawer');
      if (!_cartDrawer) return;
      if (busy) {
        _cartDrawer.setAttribute('aria-busy', 'true');
      } else {
        _cartDrawer.removeAttribute('aria-busy');
      }
    }

    async function maybeAutoAddShippingProtection(cartItems) {
      if (_autoAddInProgress) return;
      _autoAddInProgress = true;
      setCartDrawerBusy(true);
      try {
        const sp = await getShippingProtectionVariant();
        if (!sp) return;
        const alreadyInCart = cartItems?.some((item) => item.product_id === sp.productId);
        if (alreadyInCart) return;

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        const cartContent = await addShippingProtection(sp.variantId, sectionsToBundle);
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'shipping-protection:auto-add', cart: cartContent },
          })
        );
      } catch {
        // silently fail
      } finally {
        setCartDrawerBusy(false);
        _autoAddInProgress = false;
      }
    }

    async function autoRemoveShippingProtection() {
      if (_autoAddInProgress) return;
      _autoAddInProgress = true;
      setCartDrawerBusy(true);
      try {
        const sp = await getShippingProtectionVariant();
        if (!sp) return;
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );
        const cartContent = await removeShippingProtection(sp.productId, sectionsToBundle);
        if (window.themeVariables?.settings?.pageType === 'cart') {
          window.location.reload();
          return;
        }
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'shipping-protection:auto-remove', cart: cartContent },
          })
        );
      } catch {
        // silently fail
      } finally {
        setCartDrawerBusy(false);
        _autoAddInProgress = false;
      }
    }

    // On every cart change (add/remove), check if shipping protection needs to be added/removed.
    // cart:change includes the full cart in event.detail — no DOM lookup needed.
    document.addEventListener('cart:change', (event) => {
      const cart = event.detail?.cart;
      if (!cart) return;

      const spNowInCart = _spProductId
        ? !!cart.items?.some((item) => item.product_id === _spProductId)
        : false;

      // Always update tracking state — including after our own events — so
      // removal detection works correctly on the very next cart:change.
      const prevWasInCart = _spWasInCart;
      _spWasInCart = spNowInCart;

      // Skip our own managed events after state is updated.
      if (event.detail?.baseEvent === 'shipping-protection:auto-add') return;
      if (event.detail?.baseEvent === 'shipping-protection:auto-remove') return;

      // Detect removal via line-item remove button (toggle handler sets _userOptedOut directly).
      if (prevWasInCart && !spNowInCart && event.detail?.baseEvent !== 'shipping-protection:toggle') {
        _userOptedOut = true;
      }

      // Auto-remove SP if only SP is left in cart (last regular item was removed).
      if (spNowInCart && _spProductId) {
        const nonSpItemCount = cart.items?.filter((item) => item.product_id !== _spProductId).length || 0;
        if (nonSpItemCount === 0) {
          _userOptedOut = false;
          sessionStorage.removeItem('sp_opted_out');
          autoRemoveShippingProtection();
          return;
        }
      }

      if (!cart.item_count || _userOptedOut || spNowInCart) return;
      if (window.themeVariables?.settings?.pageType === 'cart') return;
      maybeAutoAddShippingProtection(cart.items);
    });

    // Handle page load when cart already has items — deferred to idle to avoid blocking DCL.
    const runSpInit = async () => {
      try {
        const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        if (!cart || cart.item_count === 0) return;
        const sp = await getShippingProtectionVariant();
        if (!sp) return;
        // Initialize _spWasInCart so removal detection works from the first interaction.
        _spWasInCart = !!cart.items?.some((item) => item.product_id === sp.productId);

        // If SP is in cart but no other items, remove it (stale SP from a previous session).
        if (_spWasInCart) {
          const nonSpItemCount = cart.items?.filter((item) => item.product_id !== sp.productId).length || 0;
          if (nonSpItemCount === 0) {
            _userOptedOut = false;
            sessionStorage.removeItem('sp_opted_out');
            await removeShippingProtection(sp.productId, []);
            if (window.themeVariables?.settings?.pageType === 'cart') window.location.reload();
            return;
          }
        }

        if (_spWasInCart || _userOptedOut) return;
        if (window.themeVariables?.settings?.pageType === 'cart') {
          // On the cart page, auto-add SP and reload to update displayed totals.
          await addShippingProtection(sp.variantId, []);
          window.location.reload();
        } else {
          maybeAutoAddShippingProtection(cart.items);
        }
      } catch {
        // silently fail
      }
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(runSpInit, { timeout: 3000 });
    } else {
      window.addEventListener('load', runSpInit, { once: true });
    }

    // On the cart page: add SP silently when checkout is clicked, then proceed.
    document.addEventListener('submit', async (event) => {
      if (window.themeVariables?.settings?.pageType !== 'cart') return;
      const form = event.target.closest('form');
      if (!form?.querySelector('[name="checkout"]')) return;

      const toggle = document.querySelector('[data-shipping-protection-toggle]');
      if (!toggle?.checked) return;

      // Must prevent default synchronously — before any await — otherwise
      // the browser submits the form before preventDefault() has any effect.
      event.preventDefault();

      try {
        const sp = await getShippingProtectionVariant();
        if (sp) {
          const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
          const alreadyInCart = cart.items?.some((item) => item.product_id === sp.productId);
          if (!alreadyInCart) {
            await addShippingProtection(sp.variantId, []);
          }
        }
      } catch {
        // silently fail — proceed to checkout anyway
      }
      window.location.href = `${Shopify.routes.root}checkout`;
    });

    async function addShippingProtection(variantId, sectionsToBundle) {
      const formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', '1');
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', `${Shopify.routes.root}variants/${variantId}`);

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      const responseJson = await response.json();
      if (!response.ok) throw new Error(responseJson?.description || 'Failed to add shipping protection');

      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent.sections = responseJson.sections || {};
      return cartContent;
    }

    async function removeShippingProtection(productId, sectionsToBundle) {
      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      const item = cartContent.items?.find((line) => line.product_id === productId);
      if (!item) return cartContent;

      const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: 0,
          sections: sectionsToBundle.join(','),
        }),
      });

      if (!response.ok) throw new Error('Failed to remove shipping protection');
      return await response.json();
    }

    document.addEventListener('change', async (event) => {
      const toggle = event.target.closest('[data-shipping-protection-toggle]');
      if (!toggle) return;

      const variantId = toggle.getAttribute('data-variant-id');
      const productId = parseInt(toggle.getAttribute('data-product-id'), 10);
      if (!variantId || !productId) return;

      toggle.disabled = true;
      setCartDrawerBusy(true);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      try {
        let cartContent;
        if (toggle.checked) {
          _userOptedOut = false;
          sessionStorage.removeItem('sp_opted_out');
          cartContent = await addShippingProtection(variantId, sectionsToBundle);
        } else {
          _userOptedOut = true;
          sessionStorage.setItem('sp_opted_out', '1');
          cartContent = await removeShippingProtection(productId, sectionsToBundle);
        }

        if (window.themeVariables?.settings?.pageType === 'cart') {
          window.location.reload();
          return;
        }

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'shipping-protection:toggle',
              cart: cartContent,
            },
          })
        );
      } catch (err) {
        toggle.checked = !toggle.checked;
      } finally {
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
        setCartDrawerBusy(false);
        toggle.disabled = false;
      }
    });
  })();
  
  (function () {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    let savedScrollY = 0;
    let isRestoring = false;
    let preventScrollFlag = false;
    let disableRestoreUntil = 0;

    const getScrollY = () => window.scrollY ?? window.pageYOffset ?? 0;

    const saveScroll = () => {
      savedScrollY = getScrollY();
    };

    const restoreScroll = () => {
      if (savedScrollY > 100) {
        isRestoring = true;
        window.scrollTo(0, savedScrollY);
        setTimeout(() => (isRestoring = false), 100);
      }
    };

    const tryRestoreIfNeeded = () => {
      if (Date.now() < disableRestoreUntil || isRestoring) return;
      if (getScrollY() === 0 && savedScrollY > 100) restoreScroll();
    };

    document.addEventListener('scrolltotop:click', () => {
      savedScrollY = 0;
      disableRestoreUntil = Date.now() + 1000;
    });

    saveScroll();

    window.addEventListener(
      'scroll',
      () => {
        if (!isRestoring && !preventScrollFlag) {
          const current = getScrollY();
          if (current > 0) savedScrollY = current;
        }
      },
      { passive: true }
    );

    document.addEventListener(
      'click',
      e => {
        saveScroll();
        preventScrollFlag = true;

        requestAnimationFrame(tryRestoreIfNeeded);
        setTimeout(() => requestAnimationFrame(tryRestoreIfNeeded), 200);

        setTimeout(() => (preventScrollFlag = false), 500);

        const link = e.target.closest('a');
        if (link && (link.getAttribute('href') === '#' || link.getAttribute('href') === 'javascript:void(0);')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      },
      true
    );
  })();

  (function () {
    const button = document.querySelector('[data-scroll-to-top]');
    if (!button) return;

    const getScrollY = () => window.scrollY ?? window.pageYOffset ?? 0;

    const toggleVisibility = () => {
      button.classList.toggle('is-visible', getScrollY() > 300);
    };

    button.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('scrolltotop:click'));
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (err) {
        window.scrollTo(0, 0);
      }
    });

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
  })();
  
  (function () {
    const header = document.querySelector('x-header');
    if (!header) return;
  
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // reserved for future header state handling
        }
      });
    });
  
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  })();
  
  (function () {
    document.addEventListener(
      'submit',
      e => {
        const form = e.target;
        if (form.tagName !== 'FORM' || !form.closest('product-form')) return;
  
        let variantIdInput = form.elements.id || form.querySelector('input[name="id"]');
  
        if (!variantIdInput) {
          variantIdInput = document.createElement('input');
          variantIdInput.type = 'hidden';
          variantIdInput.name = 'id';
          form.appendChild(variantIdInput);
        }
  
        if (variantIdInput.disabled) variantIdInput.disabled = false;
  
        if (!variantIdInput.value || variantIdInput.value === '0') {
          const scripts = document.querySelectorAll('script[data-variant]');
          for (const script of scripts) {
            try {
              const data = JSON.parse(script.textContent);
              if (data?.id) {
                variantIdInput.value = data.id;
                break;
              }
            } catch {}
          }
        }
  
        if (!variantIdInput.value || variantIdInput.value === '0') {
          e.preventDefault();
          alert('Please select a product option before adding to cart.');
          return false;
        }
      },
      true
    );
  })();
  
  (function () {
    'use strict';
  
    const initializedMenus = new WeakSet();
  
    function activateByIndex(menu, index) {
      const parents = [...menu.querySelectorAll('[data-mega-parent]')];
      const panels = [...menu.querySelectorAll('[data-mega-panel]')];
      const promos = [...menu.querySelectorAll('[data-mega-promo]')];
  
      parents.forEach((p, i) => p.classList.toggle('is-mega-parent-active', i === index));
      panels.forEach((p, i) => p.classList.toggle('is-mega-panel-active', i === index));
      promos.forEach((p, i) => p.classList.toggle('is-mega-promo-active', i === index));
    }
  
    function initMegaMenu(menu) {
      if (initializedMenus.has(menu)) return;
      initializedMenus.add(menu);
  
      const parents = [...menu.querySelectorAll('[data-mega-parent]')];
      parents.forEach((parent, i) => {
        const target = parent.querySelector('[data-mega-parent-link]') || parent;
        target.addEventListener('mouseenter', () => activateByIndex(menu, i));
        target.addEventListener('focusin', () => activateByIndex(menu, i));
      });
  
      activateByIndex(menu, 0);
    }
  
    const initAll = () => document.querySelectorAll('[data-mega-menu]').forEach(initMegaMenu);
  
    const scheduleInitAll = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(initAll, { timeout: 2000 });
      } else {
        setTimeout(initAll, 200);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleInitAll);
    } else {
      scheduleInitAll();
    }
  
    const megaMenuRoot = document.querySelector('header, [data-header], #shopify-section-header') || document.body;
    new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.hasAttribute?.('data-mega-menu')) initMegaMenu(node);
            node.querySelectorAll?.('[data-mega-menu]').forEach(initMegaMenu);
          }
        });
      });
    }).observe(megaMenuRoot, { childList: true, subtree: true });
  })();
  